/** Espelha `AnnouncementBodyFormat` do backend: o corpo do comunicado é o HTML do editor. */
export enum AnnouncementBodyFormat {
  HTML = 'HTML',
}
